export default {
    top_menu: [
        {name:'Ana fikir',    id:0},
        {name:'Gösteri işi', id:1},
        {name:'pişirmek',  id:2},
        {name:'Siyaset',   id:3},
        {name:'+18',  id:4},
        {name:'Toplum',   id:5},
        {name:'Sağlık',   id:6},
    ],
    read_other: 'Devamını oku',
    read_more:  'daha fazla detay',
    not_found:  'Hiçbirşey Bulunamadı',
    read_also:  'Ayrıca okuyun',
    copy_rights: 'Copyright © 2019 «mixer-novostei.ru». Her hakkı saklıdır.',
    subscribe: 'Abone olmak',
    thank_order: 'SİPARİŞİNİZ İÇİN TEŞEKKÜRLER',
        specialist_contact: 'Uzmanımız en kısa sürede sizinle iletişime geçecektir, aramamızı bekleyin.',
    attention: 'Ortaklardan indirimler:',
    hurry: 'Acele edin, indirim aktivasyon süresi sınırlıdır! Bu eşsiz ürünlerden birini seçmek için sadece <span id="time" class="time">30:00</span> dakikanız var.',
    hour_ago1: "Bir saat önce",
        hour_ago2: "saat önce",
    hour_ago3: "saat önce",
    new_publications: "Yeni yayınlar",
    read: "Okumak",
    today_at: "Bugün",
    author_names: ['Ajda Pekkan','Candan Erşetin','Sezen Aksu'],
    main_news: "Ana Haber",
    leave_already: "Zaten gidiyor musun? Bekleyin, haberleri sizin için güncelledik",
    already_shared: "zaten paylaşıldı"
}